import { Link as BaseRouterLink } from 'react-router-dom';
import { Link as StencilLink } from '@amzn/stencil-react-components/link';

export const RouterLink = StencilLink.withComponent(BaseRouterLink);

RouterLink.defaultProps = {
  ...StencilLink.defaultProps
};
